import React, { useState } from 'react';

const CartElementMobile = (props) => {
    const arr = props.data;
    const arrEntries = Object.entries(arr);
    const keyValue = {};
    arrEntries.forEach(el => {
        const key = el[0];
        const value = el[1];
        keyValue[key] = value;
    });

    const [product, setProduct] = useState(keyValue);

    const handleQuantityChange = (event) => {
        event.preventDefault();
        let name = event.target.name;
        let value = event.target.value;

        // Validate the quantity input
        if (parseInt(value) > 0 && parseInt(value) <= 99999) {
            const updatedProduct = {
                ...product,
                [name]: parseInt(value) // Ensure the quantity is a number
            };
            setProduct(updatedProduct);
            props.updateCartItem(updatedProduct);
        }
    };

    const incrementQuantity = () => {
        const newQuantity = product.quantity + 1;
        const updatedProduct = {
            ...product,
            quantity: newQuantity
        };
        setProduct(updatedProduct);
        props.updateCartItem(updatedProduct);
    };

    const decrementQuantity = () => {
        if (product.quantity > 1) { // Prevent decrementing below 1
            const newQuantity = product.quantity - 1;
            const updatedProduct = {
                ...product,
                quantity: newQuantity
            };
            setProduct(updatedProduct);
            props.updateCartItem(updatedProduct);
        }
    };

    return (
        <React.Fragment>
            <div className="row cart-data-mobile">
                <div className="cart-image">
                    {props.data.Book_cover !== null ? (
                        <img alt="" src={`data:image/jpeg;base64,${props.data.Book_cover}`} className="book-cover-image" />
                    ) : (
                        <img className="book-cover-image" src="ElsevierStyleSheet/images/ElsevierImage.png" alt="" />
                    )}
                </div>

                <div className="product-description">
                    <p className="font-16">{props.data.title}</p>
                    <p className="font-14 margin-0"><strong>ISBN: </strong>{props.data.isbn}</p>
                    <div className="together">
                        <label>Qty</label>
                        <div className="quantity-controls">
                            <button type="button" onClick={decrementQuantity} disabled={product.quantity <= 1}>-</button>
                            <input
                                type="number"
                                min="1"
                                max="99999"
                                name="quantity"
                                value={product.quantity}
                                onChange={handleQuantityChange}
                                className="qtyTextbox"
                            />
                            <button type="button" onClick={incrementQuantity}>+</button>
                        </div>
                    </div>
                </div>
                <div>
                    <button type="button"
                        className="es-link colored flex-row pointer at-end"
                        onClick={(event) => {
                            event.preventDefault();
                            props.deleteCartItem(props.data.cart_id, props.data.product_id);
                        }}
                    >
                        <svg viewBox="0 0 70 128" height="24" width="14">
                            <path fill="#007398" d="M68.94 36.12L62 29 35 56 8 29l-7 7 27 27L1 90l7 7                             27-27 27 27 7-7-27-27 26.94-26.88" />
                        </svg>
                        <span className="black-color-margin"> Remove</span>
                    </button>
                </div>
                <div className="flex-end">
                    <p>
                        <label className="margin-right-10p">Price</label>
                        ₹&nbsp;{props.data.total_price}
                    </p>
                    <p className="cart-discount">
                        <label className="margin-right-10p">Discount</label>
                        {props.data.discount_percentage}%&nbsp;off
                    </p>
                    <p>
                        <label className="margin-right-10p">SubTotal</label>
                        ₹&nbsp;{props.data.subtotal}
                    </p>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CartElementMobile;